import React from 'react';
import Modal from './Modal';

interface RefreshWarningModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    type: 'recording' | 'transcribing';
}

export function RefreshWarningModal({ isOpen, onClose, onConfirm, type }: RefreshWarningModalProps) {
    return (
        <Modal
            show={isOpen}
            title="Warning!"
            content={
                <div className="text-center">
                    <div className="mb-4">
                        <svg className="mx-auto h-12 w-12 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <p className="text-lg font-semibold mb-2">
                        {type === 'recording' ? 'Recording in Progress' : 'Transcription in Progress'}
                    </p>
                    <p className="text-gray-600 dark:text-gray-300">
                        {type === 'recording' 
                            ? 'You are currently recording audio. Refreshing the page will stop the recording and you may lose your data.'
                            : 'Transcription is currently in progress. Refreshing the page will interrupt the process and you may lose your data.'}
                    </p>
                    <p className="mt-4 text-gray-600 dark:text-gray-300">
                        Are you sure you want to refresh?
                    </p>
                </div>
            }
            onClose={onClose}
            submitText="Yes, Refresh"
            onSubmit={onConfirm}
        />
    );
}
